import {LEFT_SIDE_BAR} from "../Components/PartnerPortal/leftNavbar";

export default (state = true, action) => {
    switch (action.type) {
        case LEFT_SIDE_BAR:
            return action.payload;
        default:
            return state;
    }
}
